import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import {
  AttachStoreLogoDocument,
  MyStoreDocument,
  RemoveStoreLogoDocument,
} from "@/generated/graphql";
import { graphQLErrorMessage } from "@/lib/graphqlErrors";

export function useStoreLogo() {
  const [error, setError] = useState<string | null>(null);

  const [attachMutation, { loading: attaching }] = useMutation(AttachStoreLogoDocument, {
    refetchQueries: [{ query: MyStoreDocument }],
  });

  const [removeMutation, { loading: removing }] = useMutation(RemoveStoreLogoDocument, {
    refetchQueries: [{ query: MyStoreDocument }],
  });

  const attachLogo = (file: File) => {
    setError(null);
    attachMutation({
      variables: { input: { file } },
      onError: (err) =>
        setError(graphQLErrorMessage(err, "Não foi possível enviar o logo.")),
    });
  };

  const removeLogo = () => {
    setError(null);
    removeMutation({
      onError: (err) =>
        setError(graphQLErrorMessage(err, "Não foi possível remover o logo.")),
    });
  };

  return {
    attachLogo,
    removeLogo,
    attaching,
    removing,
    loading: attaching || removing,
    error,
    clearError: () => setError(null),
  };
}
